export default __webpack_public_path__ + "static/news-section-food4-image-bc5f7157f435a579e46b7cbf1b519b61.webp";